import React from 'react';
import { getCameraThumb, getDistanciaHumanized } from '../util/camera';
import './CameraThumb.css'

const CameraThumb = (props) => {
  const camera = props.camera;
  const distancia = getDistanciaHumanized(camera.distancia);

  return (
    <div className="camera-thumb"
        onClick={ props.selecionaCamera && props.selecionaCamera.bind({}, camera) }
        style={{ background: `url(${getCameraThumb(camera)})` }}>
      <div className="description">
        <p>{ distancia }</p>
        <p>{ camera.description }</p>
      </div>
    </div>
  );
};

export default CameraThumb;



// WEBPACK FOOTER //
// ./src/components/CameraThumb.js